module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_brentcomber_3.13a0cdf3.jpg";